// الترجمات الأساسية — العربية
export default {
  'common.save': 'حفظ',
  'common.cancel': 'إلغاء',
  'common.delete': 'حذف',
  'common.edit': 'تعديل',
  'common.confirm': 'تأكيد',
  'common.close': 'إغلاق',
  'common.search': 'بحث',
  'common.loading': 'جار التحميل...',
  'common.error': 'خطأ',
  'common.retry': 'إعادة المحاولة',
  'common.add': 'إضافة',
  'common.back': 'رجوع',
  'common.next': 'التالي',
  'common.all': 'الكل',
  'common.yes': 'نعم',
  'common.no': 'لا',

  'home.nav_features': 'الميزات',
  'home.nav_how': 'كيف يعمل',
  'home.nav_pricing': 'الأسعار',
  'home.nav_faq': 'الأسئلة الشائعة',
  'home.create_site': 'أنشئ موقعي',
  'home.my_space': 'مساحتي في زيفيك',
  'home.logout': 'تسجيل الخروج',

  'auth.login': 'تسجيل الدخول',
  'auth.register': 'إنشاء حساب',
  'auth.client_space': 'فضاء العميل',
  'auth.client_space_desc': 'مشترياتي وملفاتي',
  'auth.pro_space': 'الفضاء المهني',
  'auth.pro_space_desc': 'إدارة متجري',

  'dash.dashboard': 'لوحة التحكم',
  'dash.products': 'المنتجات',
  'dash.caisse': 'الصندوق',
  'dash.services': 'الخدمات',
  'dash.orders': 'الطلبات',
  'dash.customers': 'العملاء',
  'dash.credit': 'الدين',
  'dash.payments': 'المدفوعات',
  'dash.wallet': 'المحفظة',
  'dash.store': 'متجري',
  'dash.my_website': 'موقعي الإلكتروني',
  'dash.site_content': 'محتوى الموقع',
  'dash.media': 'الوسائط',
  'dash.documents': 'الوثائق',
  'dash.storage': 'التخزين',
  'dash.analytics': 'الإحصائيات',
  'dash.appstore': 'متجر التطبيقات',
  'dash.apps': 'تطبيقاتي',
  'dash.themestore': 'متجر القوالب',
  'dash.settings': 'الإعدادات',
  'dash.account': 'حسابي',
  'dash.profile': 'ملفي',
  'dash.install_app': 'تثبيت التطبيق',
  'dash.my_qr': 'رمز QR الخاص بي',
  'dash.logout': 'تسجيل الخروج',
  'dash.notifications': 'الإشعارات',
  'dash.preview_site': 'معاينة',
  'dash.view_site': 'عرض الموقع',

  'sa.dashboard': 'لوحة التحكم',
  'sa.users': 'المستخدمون',
  'sa.core': 'نواة Zifek',
  'sa.themes': 'منشئ القوالب',
  'sa.apps': 'منشئ التطبيقات',
  'sa.homepage': 'الصفحة الرئيسية',
  'sa.translations': 'اللغات والترجمات',
  'sa.support': 'دعم العملاء',
  'sa.logs': 'سجلات النظام',
  'sa.accountTypes': 'أنواع الحسابات',
  'sa.database': 'قاعدة البيانات و API',
  'sa.storage': 'التخزين',
  'sa.settings': 'إعدادات الذكاء الاصطناعي',

  'support.title': 'خدمة العملاء والدعم',
  'support.new_ticket': 'تذكرة جديدة',
  'support.subject': 'الموضوع',
  'support.message': 'الرسالة',
  'support.send': 'إرسال',
  'support.reply': 'رد',
  'support.status': 'الحالة',
  'support.open': 'مفتوح',
  'support.in_progress': 'قيد المعالجة',
  'support.resolved': 'تم الحل',
  'support.closed': 'مغلق',
  'support.zifek_team': 'فريق زيفيك',
  'support.contact_team': 'التواصل مع فريق زيفيك',
  'support.my_requests': 'طلباتي',

  'credit.title': 'زيفيك الدين',
  'credit.carnet': 'الدفتر',
  'credit.clients': 'العملاء',
  'credit.reports': 'التقارير',
  'credit.settings': 'الإعدادات',
  'credit.add_credit': 'إضافة دين',
  'credit.record_payment': 'تسجيل الدفع',
  'credit.balance': 'الرصيد',
  'credit.new_customer': 'عميل',
  'credit.import_photo': 'صورة الديون',
  'credit.scan': 'مسح',

  'lang.change': 'تغيير اللغة',

  'credit.subtitle': 'دفتر الدين الرقمي الخاص بك',
  'credit.tab.carnet': 'الدفتر',
  'credit.tab.clients': 'العملاء',
  'credit.tab.rapports': 'التقارير',
  'credit.tab.reglages': 'الإعدادات',
  'credit.photo_debts': 'صورة الديون',
  'credit.add_credit_btn': 'إضافة دين',
  'credit.search_client': 'ابحث عن عميل...',
  'cr.qa_payment': 'تسجيل الدفع',
  'cr.qa_add_client': 'إضافة عميل',
  'cr.qa_import_photo': 'استيراد من صورة',
  'cr.qa_invite': 'دعوة عميل',
  'cr.qa_statement': 'إنشاء كشف حساب',
  'cr.qa_carnet': 'الدفتر الكامل',

  'caisse.title': 'الصندوق',
  'caisse.subtitle': 'آلة تسجيل النقد',
  'caisse.search': 'ابحث عن منتج...',
  'caisse.cart': 'السلة',
  'caisse.empty': 'السلة فارغة',
  'caisse.checkout': 'تحصيل',
  'caisse.new_sale': 'بيع جديد',
  'caisse.subtotal': 'المجموع الفرعي',
  'caisse.tax': 'الضريبة',
  'caisse.total': 'المجموع',
  'caisse.cash': 'نقدا',
  'caisse.card': 'بطاقة',
  'caisse.paid': 'تم الدفع',

  'products.title': 'المنتجات',
  'products.subtitle': 'أدر كتالوج منتجاتك',
  'products.new': 'منتج جديد',
  'products.categories': 'الفئات',
  'products.catalog': 'الكتالوج',
  'products.stock_mgmt': 'إدارة المخزون',
  'products.search': 'ابحث عن منتج...',
  'reports.title': 'التقارير',

  'currency.change': 'تغيير العملة',
  'currency.equiv': 'يساوي',
  'credit.enable_reminders': 'فعّل تذكيرات الدين',

  'orders.title': 'الطلبات',
  'orders.subtitle': 'تابع وأدر جميع الطلبات',
  'orders.filter_all': 'الكل',
  'orders.filter_pending': 'قيد الانتظار',
  'orders.filter_paid': 'مدفوعة',
  'orders.filter_processing': 'قيد المعالجة',
  'orders.filter_shipped': 'تم الشحن',
  'orders.filter_delivered': 'تم التسليم',
  'orders.empty': 'لا توجد طلبات',
  'orders.empty_hint': 'ستظهر الطلبات هنا عند استلامها',
  'orders.items': 'العناصر',
  'orders.subtotal': 'المجموع الفرعي',
  'orders.shipping': 'التوصيل',
  'orders.tax': 'الضرائب',
  'orders.discount': 'الخصم',
  'orders.total': 'المجموع',
  'orders.status': 'الحالة',
  'orders.payment': 'الدفع',
  'orders.email': 'البريد الإلكتروني',
  'orders.phone': 'الهاتف',

  'payments.title': 'المدفوعات',
  'payments.subtitle': 'سجل المعاملات والإيرادات',
  'payments.received': 'مستلمة',
  'payments.sent': 'مرسلة',
  'payments.balance': 'الرصيد الحالي',
  'payments.filter_all': 'الكل',
  'payments.filter_received': 'مستلمة',
  'payments.filter_sent': 'مرسلة',
  'payments.empty': 'لا توجد معاملات',
  'payments.empty_hint': 'ستظهر المعاملات هنا',
  'payments.col_type': 'النوع',
  'payments.col_amount': 'المبلغ',
  'payments.col_details': 'التفاصيل',
  'payments.col_origin': 'المصدر',
  'payments.col_date': 'التاريخ',
  'payments.in': 'مستلمة',
  'payments.out': 'مرسلة',

  'wallet.title': 'المحفظة',
  'wallet.subtitle': 'رصيدك وعمليات التعبئة وسجل المعاملات.',
  'wallet.available': 'الرصيد المتاح',
  'wallet.recharge': 'إعادة تعبئة المحفظة',
  'wallet.via_paypal': 'التعبئة عبر PayPal',
  'wallet.via_stripe': 'التعبئة عبر Stripe',
  'wallet.history': 'سجل العمليات',
  'wallet.empty': 'لا توجد عمليات بعد.',
  'wallet.col_type': 'النوع',
  'wallet.col_amount': 'المبلغ',
  'wallet.col_method': 'الطريقة',
  'wallet.col_details': 'التفاصيل',
  'wallet.col_date': 'التاريخ',
  'wallet.type_recharge': 'تعبئة',
  'wallet.type_refund': 'استرداد',
  'wallet.type_debit': 'خصم',
  'wallet.method_wallet': 'المحفظة',
  'wallet.method_admin': 'مدير',

  'settings.title': 'الإعدادات',
  'settings.subtitle': 'أدر حسابك وتفضيلاتك',
  'settings.tab_profile': 'الملف الشخصي',
  'settings.tab_password': 'كلمة المرور',
  'settings.tab_domain': 'النطاق',
  'settings.tab_appearance': 'المظهر',
  'settings.tab_danger': 'منطقة الخطر',

  'crf.tx_add_credit': 'إضافة دين',
  'crf.tx_record_payment': 'تسجيل دفعة',
  'crf.tx_adjustment': 'تعديل',
  'crf.tx_hint_credit': 'المبلغ الذي يدين لك به العميل إضافياً',
  'crf.tx_hint_payment': 'المبلغ الذي يسدده العميل',
  'crf.tx_hint_adjustment': 'تصحيح (مبلغ سالب لتخفيض الدين)',
  'crf.current_balance': 'الرصيد الحالي',
  'crf.amount': 'المبلغ',
  'crf.description': 'الوصف',
  'crf.description_credit_ph': 'مثال: كيس أرز، زيت…',
  'crf.description_payment_ph': 'مثال: دفعة جزئية',
  'crf.payment_method': 'طريقة الدفع',
  'crf.new_balance': 'الرصيد الجديد',
  'crf.confirm': 'تأكيد',
  'crf.saving': 'جار الحفظ...',
  'crf.invalid_amount': 'أدخل مبلغاً صحيحاً.',
  'crf.save_error': 'خطأ أثناء الحفظ',
  'crf.edit_customer': 'تعديل العميل',
  'crf.new_customer': 'عميل جديد',
  'crf.customer_name': 'اسم العميل',
  'crf.customer_name_ph': 'مثال: محمد العلمي',
  'crf.customer_hint': 'لا حاجة لحساب زيفيك. يمكن دعوة العميل لاحقاً لمتابعة رصيده.',
  'crf.phone_optional': 'الهاتف (اختياري)',
  'crf.credit_limit_optional': 'سقف الدين (اختياري)',
  'crf.usual_payment_date': 'تاريخ الدفع المعتاد',
  'crf.not_defined': 'غير محدد',
  'crf.day_of_month': 'يوم {day} من الشهر',
  'crf.notes_optional': 'ملاحظات (اختياري)',
  'crf.notes_ph': 'مثال: جار، يدفع آخر الشهر…',
  'crf.name_required': 'اسم العميل مطلوب.',
  'crf.create_customer': 'إنشاء العميل',
  'crf.client_access': 'دخول العميل',
  'crf.client_access_desc': 'هذه بيانات دخول العميل. شاركها معه ليتمكن من الدخول إلى فضائه ومتابعة رصيده وسجله.',
  'crf.username': 'المعرّف',
  'crf.default_password': 'كلمة المرور الافتراضية',
  'crf.client_space': 'فضاء العميل',
  'crf.share': 'مشاركة',
  'crf.regen_password': 'إعادة توليد كلمة مرور',
  'crf.creds_hint': 'يمكن للعميل أيضاً تغيير كلمة المرور من فضائه.',
  'crf.import_title': 'استيراد الديون من صورة',
  'crf.import_sub_upload': 'صوّر صفحة الدفتر',
  'crf.import_sub_confirm': 'التأكيد مطلوب',
  'crf.import_sub_review': 'راجع ثم أكّد',
  'crf.import_desc': 'خذ صورة أو أكثر لصفحة الدفتر (الأسماء + المبالغ). يقرأ الذكاء الاصطناعي الديون ويعرضها للتحقق. لا يُحفظ شيء قبل تأكيدك.',
  'crf.take_photos': 'التقط / اختر صوراً',
  'crf.photos_hint': 'حتى 8 صور · JPG، PNG',
  'crf.import_history': 'سجل الاستيراد',
  'crf.import_cancelled': 'ملغى',
  'crf.cancel_btn': 'إلغاء',
  'crf.revert_hint': 'إلغاء الاستيراد يحذف الديون المُنشأة (والعملاء المُنشأين بهذا الاستيراد).',
  'crf.add_line': 'إضافة سطر',
  'crf.detected_total': '{count} دين مكتشف · الإجمالي {total}',
  'crf.debt_detail_ph': 'التفصيل (مثال: كيسا دقيق، خبز…)',
  'crf.existing_customer_tag': 'عميل موجود — سيُضاف الدين إلى حسابه',
  'crf.no_debt': 'لا يوجد دين. أضف سطراً يدوياً.',
  'crf.ai_read_none': 'لم يقرأ الذكاء الاصطناعي أي دين. جرّب صورة أوضح وأفضل إضاءة.',
  'crf.ai_failed': 'فشل تحليل الذكاء الاصطناعي',
  'crf.add_at_least_one': 'أضف ديناً واحداً على الأقل مع اسم ومبلغ.',
  'crf.confirm_existing_title': 'عميل/عملاء موجودون',
  'crf.confirm_existing_desc': 'هذه الأسماء موجودة في دفترك. هل تؤكد إضافة هذه الديون إلى حساباتهم؟',
  'crf.new_clients_count': 'سيتم أيضاً إنشاء {count} عميل جديد.',
  'crf.creating_progress': 'إنشاء العملاء والديون... {done}/{total}',
  'crf.analyse_ai': 'تحليل بالذكاء الاصطناعي',
  'crf.reading_ai': 'جار القراءة...',
  'crf.back': 'رجوع',
  'crf.validate_create': 'تأكيد وإنشاء',
  'crf.confirm_add_existing': 'تأكيد وإضافة إلى الحسابات الموجودة',
  'crf.import_failed': 'فشل الاستيراد',
  'crf.revert_failed': 'فشل الإلغاء',
  'crf.revert_question': 'إلغاء هذا الاستيراد؟',
  'crf.revert_desc': 'تم حذف {count} دين.',
  'crf.currency': 'العملة',
  'crf.currency_desc': 'تُستخدم في كل دفتر الدين.',
  'crf.default_due_day': 'يوم الاستحقاق الافتراضي',
  'crf.no_due_day': 'غير محدد',
  'crf.reminders': 'التذكيرات',
  'crf.reminders_desc': 'تُرسل التذكيرات إلى عميلك عبر تطبيق زيفيك (PWA) إن كان مثبتاً. وإن لم يكن مثبتاً، لا يُرسل أي تذكير تلقائي.',
  'crf.reminder_new_credit': 'دين جديد',
  'crf.reminder_payment': 'تأكيد الدفع',
  'crf.reminder_balance': 'الرصيد الحالي',
  'crf.reminder_due_date': 'استحقاق قريب',
  'crf.reminder_monthly': 'كشف شهري',
  'crf.default_channel': 'القناة الافتراضية',
  'crf.channel_inapp': 'تطبيق العميل (PWA)',
  'crf.merchant_qr': 'رمز دعوة التاجر',
  'crf.merchant_qr_desc': 'اعرض هذا الرمز عند الصندوق. عملاؤك المتصلون بزيفيك يمسحونه لربط حساباتهم بدفترك.',
  'crf.show_qr': 'عرض الرمز',
  'crf.last_reminders': 'آخر التذكيرات',
  'crf.save_settings': 'حفظ الإعدادات',
  'crf.saved': 'تم الحفظ!',
  'crf.qr_client': 'رمز العميل',
  'crf.merchant_invite': 'دعوة التاجر',
  'crf.link_customer': 'رابط ربط العميل',
  'crf.to_pay': 'للدفع',
  'crf.up_to_date': 'متوازن',
  'crf.limit_badge': 'السقف',
  'crf.no_phone': 'بدون هاتف',
  'crf.ledger_empty_title': 'دفترك فارغ',
  'crf.ledger_empty_desc': 'أضف عميلاً ثم سجّل ديناً في ثوانٍ — مثل دفتر ورقي لكن بدون ورق.',
  'crf.add_customer': 'إضافة عميل',
  'crf.no_client_found': 'لم يُعثر على عميل',
  'crf.export_csv': 'تصدير CSV',
  'crf.no_customer': 'لا يوجد عملاء',
  'crf.col_client': 'العميل',
  'crf.col_balance': 'الرصيد',
  'crf.col_limit': 'السقف / المتاح',
  'crf.col_due': 'الاستحقاق',
  'crf.col_actions': 'إجراءات',
  'crf.no_limit': 'لا سقف',
  'crf.available_short': 'متاح',
  'crf.linked_account': 'حساب مرتبط',
  'crf.last_activity': 'آخر',
  'crf.tooltip_add_credit': 'إضافة دين',
  'crf.tooltip_payment': 'دفعة',
  'crf.tooltip_invite': 'دعوة إلى زيفيك',
  'crf.tooltip_credentials': 'عرض بيانات الدخول',
  'crf.tooltip_edit': 'تعديل',
  'crf.tooltip_delete': 'حذف',
  'crf.stat_outstanding': 'إجمالي الدين الجاري',
  'crf.stat_with_credit': 'عملاء لديهم دين',
  'crf.stat_credits_month': 'ديون هذا الشهر',
  'crf.stat_payments_month': 'مدفوعات مستلمة هذا الشهر',
  'crf.stat_attention': 'عملاء للمتابعة',
  'crf.rep_export_balances': 'الأرصدة CSV',
  'crf.rep_export_history': 'السجل CSV',
  'crf.rep_from': 'من',
  'crf.rep_to': 'إلى',
  'crf.rep_reset': 'إعادة تعيين',
  'crf.rep_credits_period': 'الديون (الفترة)',
  'crf.rep_payments_period': 'المدفوعات (الفترة)',
  'crf.rep_adjust_period': 'التعديلات (الفترة)',
  'crf.rep_credits_vs_payments': 'الديون مقابل المدفوعات',
  'crf.rep_last_6': 'آخر 6 أشهر',
  'crf.rep_credits': 'الديون',
  'crf.rep_payments': 'المدفوعات',
  'crf.rep_client_balances': 'أرصدة العملاء',
  'crf.rep_no_balance': 'لا رصيد جارٍ',
  'crf.rep_payment_history': 'سجل المدفوعات',
  'crf.rep_no_payment': 'لا مدفوعات في الفترة',
  'crf.rep_deleted_client': 'عميل محذوف',
  'crf.rep_type_credit': 'دين',
  'crf.rep_type_payment': 'دفعة',
  'crf.rep_type_adjust': 'تعديل',

  'csf.all_categories': 'الكل',
  'csf.no_result': 'لا نتائج',
  'csf.no_active_product': 'لا منتجات نشطة',
  'csf.try_other': 'جرّب كلمة أخرى',
  'csf.add_active_hint': 'أضف منتجات بحالة "نشط"',
  'csf.out_of_stock': 'نفد المخزون',
  'csf.remaining': 'متبقٍ',
  'csf.promo': 'تخفيض',
  'csf.clear': 'إفراغ',
  'csf.click_to_add': 'اضغط على منتج لإضافته إلى السلة',
  'csf.cash_payment': 'دفع نقدي',
  'csf.card_payment': 'دفع بالبطاقة',
  'csf.amount_to_pay': 'المبلغ المطلوب',
  'csf.amount_received': 'المبلغ المستلم',
  'csf.change_to_give': 'الباقي',
  'csf.insert_card': 'أدخل أو مرر البطاقة',
  'csf.terminal_hint': 'جهاز متصل · الدفع اللاتلامسي مقبول',
  'csf.insufficient': 'المبلغ المستلم غير كافٍ.',
  'csf.processing': 'جار التحصيل...',
  'csf.validate_payment': 'تأكيد الدفع',
  'csf.back': 'رجوع',
  'csf.payment_accepted': 'تم الدفع',
  'csf.order': 'طلب',
  'csf.articles': 'العناصر',
  'csf.payment_method': 'طريقة الدفع',
  'csf.cash_label': 'نقدا',
  'csf.card_label': 'بطاقة بنكية',
  'csf.change_label': 'الباقي المُعاد',
  'csf.new_sale': 'بيع جديد',
  'csf.check_access': 'جار التحقق من الدخول...',
  'csf.load_error': 'خطأ في تحميل المنتجات',
  'csf.sale_offline_error': 'تعذّر حفظ البيع دون اتصال',
  'csf.sale_error': 'خطأ أثناء التحصيل',

  'prf.new_title': 'منتج جديد',
  'prf.new_subtitle': 'أضف منتجاً إلى كتالوجك',
  'prf.edit_title': 'تعديل المنتج',
  'prf.created': 'تم إنشاء المنتج بنجاح!',
  'prf.updated': 'تم تحديث المنتج بنجاح!',
  'prf.uploading_media': 'جار رفع الوسائط...',
  'prf.general_info': 'معلومات عامة',
  'prf.product_name': 'اسم المنتج',
  'prf.product_name_ph': 'مثال: قميص فاخر',
  'prf.description': 'الوصف',
  'prf.description_ph': 'صف منتجك...',
  'prf.category': 'الفئة',
  'prf.no_category': 'بدون فئة',
  'prf.status': 'الحالة',
  'prf.status_draft': 'مسودة',
  'prf.status_active': 'نشط',
  'prf.status_inactive': 'غير نشط',
  'prf.price': 'السعر',
  'prf.stock': 'المخزون',
  'prf.enable_promo': 'تفعيل التخفيض',
  'prf.promo_price': 'سعر التخفيض',
  'prf.media': 'الوسائط',
  'prf.cover_image': 'صورة الغلاف',
  'prf.click_drag_image': 'اضغط أو اسحب صورة',
  'prf.click_drag_video': 'اضغط أو اسحب فيديو',
  'prf.additional_images': 'صور إضافية',
  'prf.add': 'إضافة',
  'prf.short_video': 'فيديو قصير',
  'prf.variants': 'المتغيرات',
  'prf.has_variants': 'هذا المنتج له متغيرات (مقاسات، ألوان...)',
  'prf.variant_type_ph': 'النوع (مثال: المقاس)',
  'prf.variant_options_ph': 'الخيارات (مثال: S، M، L)',
  'prf.add_variant_type': 'إضافة نوع متغير',
  'prf.pricing': 'التسعير:',
  'prf.single_price': 'سعر موحّد',
  'prf.per_variant': 'سعر لكل متغير',
  'prf.combination': 'التركيبة',
  'prf.generated_combos': 'التركيبات المُنشأة',
  'prf.create_product': 'إنشاء المنتج',
  'prf.save': 'حفظ',
  'prf.saving': 'جار الحفظ...',
  'prf.creating': 'جار الإنشاء...',
  'prf.cancel': 'إلغاء',
  'prf.name_required': 'الاسم مطلوب',
  'prf.invalid_price': 'سعر غير صالح',
  'prf.invalid_stock': 'مخزون غير صالح',
  'prf.invalid_promo': 'سعر تخفيض غير صالح',
  'prf.image_url': 'صورة (URL)',
  'prf.view_details': 'عرض التفاصيل',
  'prf.edit_btn': 'تعديل',
  'prf.uploading': 'جار الرفع...',
  'home.hero.badge': 'الانطلاق الرسمي — عرض الرواد الأوائل',
  'home.hero.title1': 'مشروعك على الإنترنت،',
  'home.hero.title2prefix': 'في',
  'home.hero.highlight': 'دقائق',
  'home.hero.subtitle': 'زيفيك تجمع قوة Shopify وWix وFiverr في منصة واحدة مدعومة بالذكاء الاصطناعي. أنشئ متجرك الإلكتروني أو موقعك أو سوقك — بدون برمجة.',
  'home.hero.cta1': 'ابدأ مجاناً',
  'home.hero.cta2': 'اكتشف زيفيك',
  'home.hero.prooflabel': 'رائد أعمال يثقون بنا',
  'home.stats.badge': 'أرقام رئيسية',
  'home.stats.visits': 'زيارات مُولّدة',
  'home.stats.products': 'منتجات مُضافة',
  'home.stats.services': 'خدمات مُقدَّمة',
  'home.stats.sites': 'مواقع مُنشأة',
  'home.stats.title': 'المنصة بالأرقام',
  'home.stats.subtitle': 'أرقام حقيقية تُحسب مباشرة من منصة زيفيك.',
  'home.features.badge': 'كل شيء في واحد',
  'home.features.title': 'منصة واحدة.\nكل الإمكانيات.',
  'home.features.subtitle': 'زيفيك تعوّض 8 أدوات مختلفة. أنشئ وأدر وطوّر مشروعك من مكان واحد.',
  'home.features.i0.title': 'تجارة إلكترونية كاملة',
  'home.features.i0.desc': 'أدر منتجاتك المادية والرقمية والمتغيرات والمخزون والتوصيل. كل ما تحتاجه للبيع عبر الإنترنت.',
  'home.features.i1.title': 'تقديم الخدمات',
  'home.features.i1.desc': 'اعرض خدماتك مع الحجز عبر الإنترنت والتقويم والمواعيد والدفع المدمج.',
  'home.features.i2.title': 'ذكاء اصطناعي أصلي',
  'home.features.i2.desc': 'يولّد الذكاء الاصطناعي موقعك ووصفك وشعارك تلقائياً. صف مشروعك وتبني زيفيك كل شيء.',
  'home.features.i3.title': 'تصميم قابل للتخصيص',
  'home.features.i3.desc': 'قوالب احترافية ومحرر مرئي. خصّص كل التفاصيل دون كتابة أي سطر برمجي.',
  'home.features.i4.title': 'بوابات دفع متعددة',
  'home.features.i4.desc': 'Stripe وPayPal وCMI وPayDunya وFlutterwave. اقبل المدفوعات من كل العالم بأمان.',
  'home.features.i5.title': 'لغات وعملات متعددة',
  'home.features.i5.desc': 'الفرنسية والإنجليزية والعربية والإسبانية. كل متجر يمكن أن يكون متعدد اللغات بعملته الخاصة.',
  'home.how.badge': 'بسيط وسريع',
  'home.how.title': 'كيف يعمل؟',
  'home.how.subtitle': 'أطلق مشروعك عبر الإنترنت في 3 خطوات. بدون مهارات تقنية وبدون برمجة.',
  'home.how.hint': 'معظم المتاجر تصبح جاهزة في أقل من 10 دقائق',
  'home.how.i0.title': 'أنشئ متجرك',
  'home.how.i0.desc': 'صف نشاطك في بضع كلمات. يولّد ذكاء زيفيك موقعك الإلكتروني الكامل بمنتجاتك وتصميمك وهويّتك البصرية.',
  'home.how.i1.title': 'خصّص عالمك',
  'home.how.i1.desc': 'اختر من عشرات القوالب الاحترافية، وأضف منتجاتك، واضبط طرق الدفع والنطاق الخاص بك.',
  'home.how.i2.title': 'بِع وطوّر',
  'home.how.i2.desc': 'أطلق متجرك، واقبل المدفوعات، وأدر الطلبات، وتابع الأداء. زيفيك تتولى التقنية وأنت تركّز على مشروعك.',
  'home.testi.badge': 'شهادات',
  'home.testi.title': 'اختاروا زيفيك',
  'home.testi.subtitle': 'رائد أعمال أطلقوا مشاريعهم مع زيفيك.',
  'home.testi.i0.text': 'حوّلت زيفيك متجري على إنستغرام إلى موقع تجارة إلكترونية حقيقي في يوم واحد. تضاعفت مبيعاتي ثلاث مرات في الشهر الأول. حتى أن الذكاء الاصطناعي ولّد كل أوصاف منتجاتي!',
  'home.testi.i0.role': 'مؤسِّسة، BeautyByFatima',
  'home.testi.i1.text': 'كنت أبحث عن حل لبيع دوراتي وإدارة الحجوزات. زيفيك تفعل الاثنين بإتقان. نظام المواعيد مذهل.',
  'home.testi.i1.role': 'مدرب ومكوّن',
  'home.testi.i2.text': 'بعد تجربة Shopify وWix وWordPress، زيفيك هي المنصة الوحيدة التي تجمع كل شيء فعلاً. عملائي يحبون البساطة.',
  'home.testi.i2.role': 'الرئيس التنفيذي، DigitalSell',
  'home.testi.i3.text': 'لا أعرف شيئاً عن الحاسوب لكنني أنشأت موقعي بنفسي بفضل زيفيك. أرشدني الذكاء الاصطناعي خطوة بخطوة. إنه سحر!',
  'home.testi.i3.role': 'حرفية، MainsDorees',
  'home.pricing.badge': 'الأسعار',
  'home.pricing.title': 'خطط تناسب نموّك',
  'home.pricing.subtitle': 'ابدأ مجاناً وارتقِ عندما تكون جاهزاً. بدون التزام وبدون رسوم خفية.',
  'home.pricing.monthly': 'شهري',
  'home.pricing.annual': 'سنوي',
  'home.pricing.popular': 'الأكثر شعبية',
  'home.pricing.annual_note': 'يُدفع سنوياً',
  'home.pricing.i0.name': 'مجاني',
  'home.pricing.i0.desc': 'للبدء وتجربة المنصة',
  'home.pricing.i0.cta': 'ابدأ مجاناً',
  'home.pricing.i0.f0': 'حتى 10 منتجات',
  'home.pricing.i0.f1': 'قوالب أساسية',
  'home.pricing.i0.f2': 'نطاق فرعي زيفيك',
  'home.pricing.i0.f3': 'دفع عبر الإنترنت',
  'home.pricing.i0.f4': 'لوحة تحكم',
  'home.pricing.i0.f5': 'دعم بالبريد',
  'home.pricing.i1.name': 'شريك',
  'home.pricing.i1.desc': 'للمتاجر الصغيرة والمستقلين',
  'home.pricing.i1.cta': 'اختر شريك',
  'home.pricing.i1.f0': 'حتى 100 منتج',
  'home.pricing.i1.f1': 'قوالب مميزة',
  'home.pricing.i1.f2': 'نطاق مخصص',
  'home.pricing.i1.f3': 'كل بوابات الدفع',
  'home.pricing.i1.f4': 'الحجز والتقويم',
  'home.pricing.i1.f5': 'مدونة مدمجة',
  'home.pricing.i1.f6': 'دعم ذو أولوية',
  'home.pricing.i2.name': 'أعمال',
  'home.pricing.i2.desc': 'للشركات النامية',
  'home.pricing.i2.cta': 'اختر أعمال',
  'home.pricing.i2.f0': 'منتجات غير محدودة',
  'home.pricing.i2.f1': 'كل القوالب + محرر متقدم',
  'home.pricing.i2.f2': 'نطاق مخصص + بريد',
  'home.pricing.i2.f3': 'ذكاء متقدم (شعار، SEO، محتوى)',
  'home.pricing.i2.f4': 'سوق متعدد البائعين',
  'home.pricing.i2.f5': 'API وWebhooks',
  'home.pricing.i2.f6': 'تحليلات متقدمة',
  'home.pricing.i2.f7': 'دعم مخصص 24/7',
  'home.faq.badge': 'الأسئلة الشائعة',
  'home.faq.title': 'أسئلة متكررة',
  'home.faq.subtitle': 'كل ما تحتاج معرفته عن زيفيك.',
  'home.faq.i0.q': 'هل يمكنني فعلاً إنشاء موقع دون معرفة البرمجة؟',
  'home.faq.i0.a': 'بالتأكيد! زيفيك مصممة حتى يتمكن أي شخص، حتى بدون معرفة تقنية، من إنشاء موقع احترافي. محررنا المرئي والذكاء الاصطناعي يرشدانك خطوة بخطوة.',
  'home.faq.i1.q': 'ما أنواع الدفع التي يمكنني قبولها؟',
  'home.faq.i1.a': 'زيفيك تدعم Stripe وPayPal وCMI (المغرب) وPayDunya وFlutterwave والدفع عند التسليم. فعّل بوابة أو أكثر حسب حاجتك.',
  'home.faq.i2.q': 'هل يمكن أن يكون لي نطاق خاص؟',
  'home.faq.i2.a': 'نعم! كل متجر يحصل على نطاق فرعي مجاني (mystore.zifek.fr) ويمكنك أيضاً ربط نطاقك المخصص.',
  'home.faq.i3.q': 'كيف يعمل ذكاء زيفيك؟',
  'home.faq.i3.a': 'ببساطة صف نشاطك ويولّد الذكاء الاصطناعي موقعك الكامل تلقائياً: الصفحات والألوان والشعار والخدمات والأوصاف وبنية SEO.',
  'home.faq.i4.q': 'هل بياناتي آمنة؟',
  'home.faq.i4.a': 'الأمان أولويتنا. كل البيانات مشفّرة، والمدفوعات عبر بوابات PCI-DSS، ونسخ احتياطية يومية تلقائية.',
  'home.faq.i5.q': 'هل توجد رسوم على مبيعاتي؟',
  'home.faq.i5.a': 'زيفيك لا تأخذ أي رسوم على مبيعاتك. تدفع فقط الرسوم المعتادة لبوابة الدفع الخاصة بك.',
  'home.faq.i6.q': 'هل يمكنني نقل موقعي الحالي إلى زيفيك؟',
  'home.faq.i6.a': 'نعم، نوفر خدمة ترحيل مُرافقة لـ Shopify وWooCommerce وWix ومنصات أخرى. فريقنا يرافقك.',
  'home.cta.before': 'جاهز لإطلاق',
  'home.cta.highlight': 'مشروعك',
  'home.cta.after': 'على الإنترنت؟',
  'home.cta.subtitle': 'أنشئ موقعك مجاناً، بدون التزام، وابدأ نشاطك في دقائق.',
  'home.cta.button': 'أنشئ موقعي مجاناً',
  'home.footer.about': 'المنصة السحابية الشاملة لبناء مشروعك على الإنترنت. تجارة إلكترونية، خدمات، سوق، حجوزات. بدون برمجة ومدعومة بالذكاء الاصطناعي.',
  'home.footer.copyright': 'زيفيك. جميع الحقوق محفوظة.',
  'home.footer.account': 'الحساب',
  'home.footer.privacy': 'الخصوصية',
  'home.footer.terms': 'الشروط',
  'home.footer.cookies': 'الكوكيز',
  'home.footer.email_ph': 'بريدك الإلكتروني',
  'home.footer.subscribe': 'اشترك',
  'home.footer.subscribed': 'تم الاشتراك!',
} as Record<string, string>;